import http from "./http";
const API_ENDPOINT = `${
  import.meta.env.VITE_API_ENDPOINT
}/v1/admin/organization`;

const getAllOrganizations = async () => {
  const response = await http.get(`${API_ENDPOINT}/all`);
  return response.data;
};

const getOrganizationsWithDetails = async (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.search) params.set("search", filters.search);
  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);
  if (filters.timeZone) params.set("timeZone", filters.timeZone);

  const queryString = params.toString();

  const response = await http.get(
    `${API_ENDPOINT}/all/details${queryString ? `?${queryString}` : ""}`
  );
  return response.data;
};

const getOrganizationById = async (organizationId, filters) => {
  let filtersQuery = "";

  const startTime = filters.startTime.split("").slice(0, 2).join("");
  const endTime = filters.endTime.split("").slice(0, 2).join("");

  const startDateTimestamp = JSON.stringify(
    new Date(new Date(filters.startDate).setHours(0, 0, 0, 0)).getTime() / 1000
  );

  const endDateTimestamp = JSON.stringify(
    new Date(
      new Date(filters.endDate || new Date()).setHours(23, 59, 59)
    ).getTime() / 1000
  );

  filtersQuery += `&startDate=${startDateTimestamp}
                   &endDate=${endDateTimestamp}
                   &startTime=${startTime}
                   &endTime=${endTime}
                   &weekdays=${filters.weekdays ? 1 : 0}
                   &weekends=${filters.weekends ? 1 : 0}`;

  if (filters.timeZone) {
    filtersQuery += `&timeZone=${encodeURIComponent(filters.timeZone)}`;
  }

  if (filters.search) {
    filtersQuery += `&search=${filters.search}`;
  }

  const response = await http.get(
    `${API_ENDPOINT}/${organizationId}?${filtersQuery}`
  );
  return response.data;
};

const createOrganization = async (payload) => {
  const response = await http.post(`${API_ENDPOINT}/`, payload);
  return response.data;
};

const editOrganization = async (payload) => {
  const response = await http.put(`${API_ENDPOINT}/`, payload);
  return response.data;
};

const assignProvidersToOrganization = async (payload) => {
  const response = await http.post(`${API_ENDPOINT}/assign-provider`, payload);
  return response.data;
};

const removeProviderFromOrganization = async (payload) => {
  const response = await http.put(`${API_ENDPOINT}/remove-provider`, payload);
  return response.data;
};

async function getOrganizationMetadata() {
  const response = await http.get(`${API_ENDPOINT}/metadata`);
  return response.data;
}

async function deleteOrganization(organizationId) {
  const response = await http.delete(`${API_ENDPOINT}/${organizationId}`);
  return response.data;
}

async function translateText(payload) {
  const response = await http.post(`${API_ENDPOINT}/translate`, payload);
  return response.data;
}

const exportedFunctions = {
  getAllOrganizations,
  getOrganizationsWithDetails,
  getOrganizationById,
  createOrganization,
  editOrganization,
  assignProvidersToOrganization,
  removeProviderFromOrganization,
  getOrganizationMetadata,
  deleteOrganization,
  translateText,
};

export default exportedFunctions;
